import { jsx as _jsx } from "react/jsx-runtime";
const style = {
    padding: 10,
    backgroundColor: '#f1f1f1',
    height: '100%',
    overflowY: 'auto',
};
export function PreferencesContainer({ children }) {
    return _jsx("div", { style: style, children: children });
}
